export default {
      id: "color_guy2-usage",
      viewBox: "0 0 138 192",
      url: __webpack_public_path__ + "sprite.svg#color_guy2",
      toString: function () {
        return this.url;
      }
    }